/* eslint-disable eqeqeq */
/* eslint-disable no-loop-func */
/* eslint-disable react-hooks/exhaustive-deps */
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import DollarInput from "main/components/DollarInput/DollarInput";
import React, { useEffect, useState } from "react";
import ScrollBar from "react-perfect-scrollbar";
import { useNavigate } from "react-router-dom";
import { createTest } from "../../../services/TestService";
import CustomInput from "../../components/Custom/CustomInput";
import {
  deleteArrayIndex,
  getErrorMsg,
  showToast,
  updateArrayIndex,
} from "../../shared/helpers";
import "./style.css";

export default function AddTest() {
  const [name, setName] = useState("");
  const [tests, setTests] = useState([{ sampleType: "", cost: "" }]);
  const [sampleInfos, setSampleInfos] = useState([""]);

  const [isSaving, setIsSaving] = useState(false);
  const [disableSave, setDisableSave] = useState(false);
  const navigate = useNavigate();

  const handleSave = () => {
    setIsSaving(true);
    const test_samples = [];
    const test_costs = [];

    tests.forEach((item) => {
      test_samples.push(item.sampleType);
      test_costs.push(item.cost.replace("$", "").replaceAll(",", ""));
    });

    const extraInfo = ["Lab Code", "Sample Location"];
    const fullSampleInfo = [...sampleInfos, ...extraInfo];

    // Case-insensitive duplicate check
    const lowerCasedMap = {};
    const duplicates = [];

    fullSampleInfo.forEach((info) => {
      const key = info.trim().toLowerCase();
      lowerCasedMap[key] = (lowerCasedMap[key] || 0) + 1;
    });

    extraInfo.forEach((entry) => {
      const key = entry.toLowerCase();
      if (lowerCasedMap[key] > 1) duplicates.push(entry);
    });

    if (duplicates.length) {
      showToast(`Duplicate entry found for: ${duplicates.join(", ")}`, false);
      setIsSaving(false);
      return;
    }

    const data = {
      name,
      sample_info: fullSampleInfo,
      test_samples,
      test_costs,
    };

    createTest(data)
      .then((res) => {
        showToast("Test created successfully", true);
        navigate("/tools/tests", { replace: true });
      })
      .catch((err) => {
        showToast(getErrorMsg(err) || "Unable to create test.");
      })
      .finally(() => setIsSaving(false));
  };

  useEffect(() => {
    if (name && tests[0].sampleType && tests[0].cost) {
      setDisableSave(false);
    } else {
      setDisableSave(true);
    }
  }, [name, sampleInfos, tests]);

  return (
    <div className="main">
      <ScrollBar style={{ height: "calc(100vh - 90px)" }}>
        <div className="main-content-area">
          <div className="d-flex align-items-center justify-content-end">
            <button
              className={`btn btn-primary ml-auto`}
              id="add_test"
              onClick={handleSave}
              disabled={isSaving || disableSave}
            >
              Save
            </button>
          </div>

          <div className="row py-4">
            <div className="col-md-6 col-sm-12" style={{ marginLeft: "15px" }}>
              <h4>What Kind Of Test Is This?</h4>
              <div className="form-group">
                <CustomInput
                  label="Test Type"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  inputProps={{ maxLength: "50" }}
                />
              </div>
            </div>
          </div>

          <div
            className="d-flex flex-row justify-content-between ps-3 pe-3"
            style={{ marginLeft: "15px" }}
          >
            <h4>What Info Needs To Be Sampled?</h4>
            <button
              className="btn btn-primary me-1"
              onClick={() => {
                setSampleInfos([...sampleInfos, ""]);
              }}
              disabled={sampleInfos.length === 3}
            >
              Add Sample Info <AddIcon />
            </button>
          </div>
          <div className="pe-3 ps-3" style={{ marginLeft: "15px" }}>
            <div className="row">
              {sampleInfos.map((_, i) => (
                <div className="col-md-5 col-sm-12" key={`sample-info-${i}`}>
                  <div className="form-group d-flex flex-row align-items-center mb-3">
                    <CustomInput
                      label="Sample Info"
                      disabled={sampleInfos[i] === "sample_info"}
                      value={sampleInfos[i]}
                      onChange={(e) => {
                        setSampleInfos((state) =>
                          updateArrayIndex(i, state, e.target.value)
                        );
                      }}
                      inputProps={{ maxLength: "50" }}
                      parentClassName="webkit-fill-available"
                    />
                    <CloseIcon
                      style={{
                        fontSize: "18px",
                        marginLeft: "5px",
                        fontweight: "900",
                      }}
                      className="text-light50 cursor-pointer"
                      onClick={() =>
                        setSampleInfos((state) => deleteArrayIndex(i, state))
                      }
                    />
                  </div>
                </div>
              ))}
            </div>
            <div className="row">
              <div className="col-md-5 col-sm-12">
                <CustomInput
                  label="Sample Info"
                  disabled={true}
                  value="Lab Code"
                  inputProps={{ maxLength: "50" }}
                  parentClassName="webkit-fill-available"
                />
              </div>
              <div className="col-md-5 col-sm-12">
                <div className="form-group d-flex flex-row align-items-center">
                  <CustomInput
                    label="Sample Info"
                    disabled={true}
                    value="Sample Location"
                    inputProps={{ maxLength: "50" }}
                    parentClassName="webkit-fill-available"
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            className="d-flex flex-row justify-content-between pe-3 ps-3 pt-3"
            style={{ marginLeft: "15px" }}
          >
            <h4>What Are You Testing For?</h4>
            <button
              className="btn btn-primary me-1"
              onClick={() => {
                setTests([...tests, { sampleType: "", cost: "" }]);
              }}
              disabled={tests.length === 15}
            >
              Add Sample Type <AddIcon />
            </button>
          </div>
          {tests.map((_, i) => (
            <div className="row pe-3 ps-3" key={`test-${i}`}>
              <div
                className="form-group col-md-4 mb-3"
                style={{ marginLeft: "15px" }}
              >
                <CustomInput
                  label="Sample Type"
                  value={tests[i].sampleType}
                  onChange={(e) =>
                    setTests((state) =>
                      updateArrayIndex(i, state, {
                        sampleType: e.target.value,
                        cost: tests[i].cost,
                      })
                    )
                  }
                  inputProps={{ maxLength: "50" }}
                />
              </div>
              <div className="form-group col-md-4">
                <div className="form-group d-flex flex-row align-items-center">
                  <DollarInput
                    label="Customer Cost"
                    type="text"
                    className="form-control"
                    value={tests[i].cost}
                    onChange={(e) => {
                      setTests((state) =>
                        updateArrayIndex(i, state, {
                          sampleType: tests[i].sampleType,
                          cost: e.target.value,
                        })
                      );
                    }}
                  />

                  <CloseIcon
                    style={{
                      fontSize: "18px",
                      marginLeft: "5px",
                      fontweight: "900",
                    }}
                    className="text-light50 cursor-pointer"
                    onClick={() =>
                      tests.length !== 1 &&
                      setTests((state) => deleteArrayIndex(i, state))
                    }
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </ScrollBar>
    </div>
  );
}
